import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import { intl } from 'src/i18n'

type HeaderProps = {
  setHeaderLoaded: (data: any) => void
}

export const Header = ({ setHeaderLoaded }: HeaderProps) => {
  const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

  useEffect(() => {
    async function changeHeaderLoad() {
      await delay(500)
      setHeaderLoaded(true)
    }
    changeHeaderLoad()
  }, [setHeaderLoaded])

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <h1 className={styles.title}>{intl.t('newsletter.header.title')}</h1>
        <h2 className={styles.subtitle}>
          {intl.t('newsletter.header.subtitle')}
        </h2>
        <iframe
          className={styles.iframe}
          src={`https://cdn.forms-content.sg-form.com/98388cb6-dd00-11ed-bba7-b2a480f00fab`}
        />
      </div>
      <div className={styles.image}>
        <Image
          src={`/assets/images/newsletter/robot.svg`}
          width='440'
          height='440'
          alt='robot'
        />
      </div>
    </div>
  )
}
